module.exports = __webpack_public_path__ + "static/media/ResumeApril2020.a751fba6.pdf";